import styled from "styled-components/macro";
import { COLORES } from "../../constants";

export const Container = styled.div`
  font-size: 0.8rem;
  background-color: ${COLORES.BACKGROUND};
  button {
    cursor: pointer;
  }
  .btn-group-sm {
    margin-top: 10px;
  }
`;

export const TableContainer = styled.div`
  max-height: 58vh;
  height: ${({ heightSize }) => (!!heightSize ? heightSize : "")};
  overflow: auto;
  table {
    thead {
      z-index: 1;
    }
    td {
      vertical-align: middle;
    }
  }
`;
